import React, { Component } from 'react'
import { Col, Row, FormGroup } from "react-bootstrap"
import { reduxForm, propTypes, formValueSelector, getFormSyncErrors } from 'redux-form'
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types'
import { green } from '../../../utils/constants'
import { deleteSeasonDivision } from "../../../redux/actions/seasonActions"
import ErrorList from './ErrorList'
import SeasonHeader from './SeasonHeader'
import DivisionsTable from './DivisionsTable'
import DivisionsAdd from './DivisionsAdd'
import InfoSaved from './InfoSaved'

const formName = 'seasondivisions'

class Divisions extends Component {
	static propTypes = {
		...propTypes
	}

	constructor(props,context) {
		super(props,context)
		this.state = {
			errors: [],
			tableView:true
		};

		this.handleViewChange = this.handleViewChange.bind(this),
    this.onHandleDeleteDivision = this.onHandleDeleteDivision.bind(this)
	}

	handleViewChange(){
		const { tableView } = this.state
		if(tableView){
			this.setState({			
				tableView:false
			});  
		} else {
			this.setState({			
				tableView:true
			}); 
		}
  }

  onHandleDeleteDivision(id) {
    const { dispatch } = this.props
    dispatch(deleteSeasonDivision(id));
  }

	render() {
		const {
			tableView,
			errors
		} = this.state

		const { 
			savingdata,
			datasaved,
			seasonyears,
			divisions,
			settingsseason
		} = this.props

		let seasondivisions = []

		if(divisions && settingsseason){
			seasondivisions = divisions[settingsseason].divisions
		}
		
		return (
			<Row className="center-block center-text">
				<Col sm={7}>
					<FormGroup>
						<SeasonHeader seasonyears={seasonyears} />   
					</FormGroup> 
					<FormGroup>
						{
							(errors.length > 0) && <ErrorList errors={errors}/>
						}
					</FormGroup>	
					{
						(tableView === true)
						?<FormGroup>
                {
                  <DivisionsTable
                    divisions={seasondivisions}
                    deleteDivision={this.onHandleDeleteDivision}
							/>
						}
						</FormGroup>
						:<FormGroup>
							{
								<DivisionsAdd
									seasonId={settingsseason}
									onDivisionCancel = {this.handleViewChange}
									onDivisionSave = {this.handleViewChange}
								/>
							}
						</FormGroup>
					}
					{ 
						(tableView) &&  
						<FormGroup> 
							<Col sm={10}>
								<button type='button' className="btn btn-default" style={{ color: green, fontWeight: 800 }} onClick={this.handleViewChange} >
									<i className={savingdata == true ? 'fa fa-spinner fa-spin' : "fa fa-plus"} aria-hidden="true" /> &nbsp;&nbsp;Add Division
								</button>
								{
									datasaved && (<InfoSaved section='Division setup' />)
								}
							</Col>
						</FormGroup>
					}                           
				</Col>                       
			</Row>
		)
	}
}

Divisions.propTypes = {
	dispatch:PropTypes.func,
	saveSeasonDivisions:PropTypes.func,
	initialize:PropTypes.func,
	syncErrors:PropTypes.object,
	savingdata:PropTypes.bool,
	datasaved:PropTypes.bool,
  seasonId:PropTypes.string,
  id:PropTypes.string,
  seasonyears:PropTypes.string,
	settingsSaved: PropTypes.func,
	fetchSeasonDivisions: PropTypes.func,
	isSettingSeason:PropTypes.bool,
	newdivisionsaved:PropTypes.bool,
	divisions:PropTypes.object,
	settingsseason:PropTypes.number,
	initialstate: PropTypes.object,
	savingseasondivision:PropTypes.bool,
  name:PropTypes.string,
  dobStart:PropTypes.string,
  dobEnd:PropTypes.string,
  men:PropTypes.bool,
  women:PropTypes.bool,
  offerGenderDivisionOptions:PropTypes.string
}
function mapStateToProps(state,ownProps){   
	const formName =  ownProps.form
	const selector = formValueSelector(formName)
	const savingseasondivision     = selector(state,'savingseasondivision')
	const datasaved     = selector(state,'datasaved')
	const syncErrors = getFormSyncErrors(formName)(state)  
	const divisions     = selector(state,'divisions')
	const settingsseason     = selector(state,'settingsseason')
	const initialstate     = selector(state,'initialstate')
	const newdivisionsaved   = selector(state,'newdivisionsaved')
  const deleteseasondivision  = selector(state, 'deleteseasondivision')
	return {     
		savingseasondivision,
    deleteseasondivision,
		datasaved,
		syncErrors,
		divisions,
		settingsseason,
		initialstate,
		newdivisionsaved,
	}
}

export default reduxForm({
  form:formName,
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: false,
	enableReinitialize: true,
	keepDirtyOnReinitialize: true
})(connect(mapStateToProps)(Divisions))




// WEBPACK FOOTER //
// ./src/containers/season/components/Divisions.js